import axios from 'axios';
import download from 'downloadjs';
import endpoints from '../../endpoints';
import {handleError, handleRawResponse, handleResponse} from './apiUtils';

export function uploadDocument(formData) {
    const url = endpoints.documents;
    const config = {headers: {'Content-Type': 'multipart/form-data'}};

    return axios.post(url, formData, config)
        .then(handleResponse)
        .catch(handleError);
}

export function getDocument(id) {
    const url = endpoints.getDocument(id);

    return axios.get(url)
        .then(handleResponse)
        .catch(handleError);
}

export function downloadDocument(id, callback) {
    const url = endpoints.getDocumentDownload(id);
    axios.get(url, {responseType: 'blob'})
        .then(response => {
            const content = response.headers['content-type'];
            const filename = response.headers['custom-header-filename'] || 'document';
            download(response.data, filename, content);
            callback(null, response);
        })
        .catch(error => callback(error, null));
}

export function getDocumentData(id) {
    const url = endpoints.getDocumentData(id);

    return axios.get(url)
        .then(handleResponse)
        .catch(handleError);
}
